import { Message } from "../../../types/types";
import { PromotionalMessage } from "../../../types/prodcatBaseTypes";

const TRADE_IN_ENHANCED = "Trade In - Enhanced";

function getTradeInPromoMessageTitle(messages: Message[]) {
  const filterdMessages: string[] = messages
    .filter((message) => message.type === "promotional")
    .filter(
      (message) =>
        (message as PromotionalMessage).promotionType === TRADE_IN_ENHANCED,
    )
    .map((message) => message.title);

  return filterdMessages.length > 0 ? filterdMessages[0] : "";
}

function getPromotionValueFromTitle(title: string) {
  const promotionValueRegex = /(£[\w]*)/g;
  const promotionValueMatches = title.match(promotionValueRegex);

  // only consider single value matches
  if (promotionValueMatches?.length === 1) {
    return promotionValueMatches[0];
  }
  return "";
}

export function getPromotionValue(messages: Message[]) {
  const promotionTitle = getTradeInPromoMessageTitle(messages);

  // @ts-ignore
  return getPromotionValueFromTitle(promotionTitle);
}
